import React from 'react';
import styled, { StyledComponentClass } from 'styled-components';
import colors from '../../styles/colors';

export interface Props {
  className?: string;
  count: any;
  total: any;
}

class FractionString extends React.Component<Props, any> {
  render() {
    const { className, count, total } = this.props;
    return <span className={className}>{`(${count}/${total})`}</span>;
  }
}

export default styled(FractionString)`
  color: ${colors.black500};
  font-size: 0.7rem;
`;
